import {createAction} from '@reduxjs/toolkit'
import {
  AddCustomPages,
  DefaultBlockPagePayload,
  UpdateCustomPage,
  SettingThrowError,
  BlockPagesResponse,
} from 'interfaces'

const getBlockPagesSuccess = createAction<BlockPagesResponse>(
  'getBlockPagesSuccess',
)
const defaultBlockPagesUpdate = createAction<DefaultBlockPagePayload>(
  'defaultBlockPagesUpdate',
)
const defaultBlockPagesUpdateFailure = createAction<string>(
  'defaultBlockPagesUpdateFailure',
)
const defaultBlockPagesUpdateSuccess = createAction(
  'defaultBlockPagesUpdateSuccess',
)
const resetDefaultBlockPagesUpdate = createAction(
  'resetDefaultBlockPagesUpdate',
)
const customBlockPagesUpdate = createAction<{
  addCustomPages?: AddCustomPages[]
  updateCustomPages?: UpdateCustomPage[]
}>('customBlockPagesUpdate')
const customBlockPagesUpdateFailure = createAction<string>(
  'customBlockPagesUpdateFailure',
)
const customBlockPagesUpdateSuccess = createAction(
  'customBlockPagesUpdateSuccess',
)
const resetCustomBlockPagesUpdate = createAction('resetCustomBlockPagesUpdate')

const updateDefaultBlockPagePayload = createAction<DefaultBlockPagePayload>(
  'updateDefaultBlockPagePayload',
)

const updateSettingField = createAction<SettingThrowError>('updateSettingField')
const resetSettingUpdateField = createAction('resetSettingUpdateField')

const formSubmitted = createAction<boolean>('formSubmitted')
const savePressed = createAction<boolean>('savePressed')

export {
  getBlockPagesSuccess,
  defaultBlockPagesUpdate,
  defaultBlockPagesUpdateFailure,
  defaultBlockPagesUpdateSuccess,
  resetDefaultBlockPagesUpdate,
  customBlockPagesUpdate,
  customBlockPagesUpdateFailure,
  customBlockPagesUpdateSuccess,
  resetCustomBlockPagesUpdate,
  updateDefaultBlockPagePayload,
  updateSettingField,
  resetSettingUpdateField,
  formSubmitted,
  savePressed,
}
